import { Link } from "react-router-dom";
import { useLang } from "../i18n/LanguageContext";

export const Consent = ({ checked, onChange, testid }) => {
  const { t } = useLang();
  const c = t.common;
  return (
    <label className="flex items-start gap-3 cursor-pointer select-none">
      <input type="checkbox" checked={checked} onChange={(e) => onChange(e.target.checked)} className="mt-1 w-4 h-4 accent-[#2A5745]" data-testid={testid} />
      <span className="text-sm text-ink-soft">
        {c.privacyPre} <Link to="/privacidad" target="_blank" className="text-forest font-semibold underline">{c.privacyLink}</Link>.
      </span>
    </label>
  );
};
